<po-page-edit p-title="Pré-Cadastro" p-disable-submit="true">
  <div class="po-m-2" style="text-align: right;">
    <po-button
      class="po-m-1"
      p-label="Cancelar"
      (p-click)="cancel()"
    ></po-button>
    <po-button
      class="po-m-1"
      p-label="Salvar"
      (p-click)="save()"
      p-type="primary"
      [p-disabled]="formInsertProspect.invalid"
    ></po-button>
  </div>
  <form #formInsertProspect="ngForm">
    <po-divider p-label="Informações básicas"> </po-divider>
    <div class="po-row">
      <po-number
        class="po-md-2"
        name="Id"
        [(ngModel)]="id"
        p-clean
        p-label="ID"
        p-disabled="true"
      >
      </po-number>

      <po-input
        class="po-md-5"
        name="nome"
        [(ngModel)]="nome"
        p-clean
        p-required
        [p-label]="nameLabel"
      >
      </po-input>

      <po-input
        class="po-md-8"
        name="nomeFantasia"
        [(ngModel)]="nomeFantasia"
        p-clean
        p-required
        p-label="Nome Fantasia"
      >
      </po-input>

      <po-select
        class="po-md-2"
        [(ngModel)]="tipo"
        name="tipo"
        p-required
        p-label="Tipo"
        (p-change)="changeType($event)"
        [p-options]="[
          { label: 'Física', value: 'F' },
          { label: 'Jurídica', value: 'J' }
        ]"
      >
      </po-select>

      <po-input
        class="po-md-3"
        name="cgc"
        [(ngModel)]="cgc"
        p-clean
        p-mask-format-model
        p-required
        [p-label]="documentLabel"
        [p-mask]="mask"
        [p-minlength]="minLength"
      >
      </po-input>

      <po-input
        class="po-md-3"
        name="ie"
        [(ngModel)]="ie"
        p-clean
        p-required
        p-disabled="{{this.temIE}}"
        p-label="Inscricao Estadual"
      >
      </po-input>
    </div>
    <po-divider p-label="Contato"> </po-divider>
    <div class="po-row">
      <po-email
        class="po-md-4"
        name="email"
        [(ngModel)]="email"
        p-clean
        p-label="Email"
      >
      </po-email>

      <po-input
        class="po-md-4"
        name="fone"
        [(ngModel)]="telefone"
        p-clean
        p-label="Telefone"
        p-icon="po-icon po-icon-telephone"
      >
      </po-input>
    </div>
    <po-divider p-label="Endereço"> </po-divider>
    <div class="po-row">
      <po-input
        class="po-md-3"
        p-required
        name="cep"
        [(ngModel)]="cep"
        p-clean
        (p-change)="retornaEndereco()"
        p-label="CEP"
        p-icon="po-icon-pin"
      >
      </po-input>
      <po-input
        class="po-md-10"
        name="endereco"
        [(ngModel)]="endereco"
        p-required
        p-clean
        p-label="Endereço"
      >
      </po-input>
      <po-number
        class="po-md-2"
        p-required
        name="numero"
        [(ngModel)]="numero"
        p-clean
        p-label="Número"
      >
      </po-number>
      <po-input
        class="po-md-5"
        p-required
        name="bairro"
        [(ngModel)]="bairro"
        p-clean
        p-label="Bairro"
      >
      </po-input>
      <po-input
        class="po-md-5"
        p-required
        name="cidade"
        [(ngModel)]="cidade"
        p-clean
        p-label="cidade"
      >
      </po-input>
      <po-input class="po-md-2" name="uf" [(ngModel)]="uf" p-clean p-label="UF">
      </po-input>
      <po-input
        class="po-md-3"
        p-required
        name="ibge"
        [(ngModel)]="ibge"
        p-clean
        p-label="Código IBGE"
      >
      </po-input>
    </div>
  </form>
</po-page-edit>
